
import React from 'react';
import { NavLink } from 'react-router-dom';
import { Settings } from 'lucide-react';
import { cn } from '@/lib/utils';

type SidebarFooterProps = {
  expanded: boolean;
  isMobile: boolean;
  onNavigation: () => void;
};

const SidebarFooter = ({ expanded, isMobile, onNavigation }: SidebarFooterProps) => {
  return (
    <div className={cn(
      "p-3 border-t border-border mt-auto",
      !expanded && !isMobile && "flex justify-center"
    )}>
      <NavLink 
        to="/app/settings" 
        className={({ isActive }) => cn(
          "flex items-center px-3 py-2.5 rounded-md transition-colors duration-200",
          isActive 
            ? "bg-primary/10 text-primary font-medium" 
            : "text-muted-foreground hover:bg-muted hover:text-foreground",
          !expanded && !isMobile && "justify-center"
        )}
        onClick={onNavigation}
      >
        <Settings size={20} className={cn("flex-shrink-0", expanded || isMobile ? "mr-3" : "")} />
        {(expanded || isMobile) && <span>Settings</span>}
      </NavLink>
    </div>
  );
};

export default SidebarFooter;
